// styled components
import {
    Link,
    SingleLink,
    StyledDrawer
}
    from './styles';

// components
import { NavLink, useLocation } from 'react-router-dom';

// hooks
import { useSidebar } from '@contexts/sidebarContext';
import { useWindowSize } from 'react-use';
import { useAuth } from '@contexts/authContext';


const Sidebar = () => {
    const { links } = useAuth();

    const { open, setOpen } = useSidebar();

    const { pathname } = useLocation();
    const { width } = useWindowSize();

    const pages = links.flatMap(link => link.pages);

    return (
        <StyledDrawer
            variant={width < 1920 ? 'temporary' : 'permanent'}
            anchor="left"
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            sx={{
                '& .MuiDrawer-paper': {
                    width: 250,
                }
            }}
            className="main-sidebar">
            <SingleLink className={pathname === '/' ? 'pinned active' : 'pinned'} as="div">
                <NavLink to="/">
                    <Link className={`${pathname === '/' ? '' : ''} h4`}>
                        <i className="icon icon-house" /> Inicio
                    </Link>
                </NavLink>
            </SingleLink>

            <nav className="d-flex flex-column g-8 flex-1">
                {
                    pages.map(page => (
                        <SingleLink key={page.title} className={pathname === page.path ? 'active' : ''} as="div">
                            <NavLink to={page.path}>
                                <Link className={`${pathname === page.path ? 'active' : ''} h4`}>
                                    {page.icon && <i className={`icon icon-${page.icon}`} />} {page.title}
                                </Link>
                            </NavLink>
                        </SingleLink>
                    ))
                }
            </nav>
            <SingleLink className={pathname === '/statics' ? 'pinned active' : 'pinned'} as="div">
                <Link className={`${pathname === '/schedule' ? 'active' : ''} h4`}>
                    <a
                        href="https://chat.whatsapp.com/FSNbmES4AqjD8P2Hh6PaoK?mode=ems_copy_c"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="h4"
                        style={{ display: 'inline-flex', alignItems: 'center', gap: '12px' }}
                    >
                        <i className="icon icon-users-two" /> Grupos de WhatsApp
                    </a>
                </Link>
            </SingleLink>
            <SingleLink className={pathname === '/statics' ? 'pinned active' : 'pinned'} as="div">
                <Link className={`${pathname === '/schedule' ? 'active' : ''} h4`}>
                    <a
                        href="https:///torneospyd.com/REGLAMENTO_2026.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="h4"
                        style={{ display: 'inline-flex', alignItems: 'center', gap: '12px' }}
                    >
                        <i className="icon icon-book-regular" /> Reglamentación
                    </a>
                </Link>
            </SingleLink>
            <SingleLink className={pathname === '/statics' ? 'pinned active' : 'pinned'} as="div">
                <NavLink to="/schedule">
                    <Link className={`${pathname === '/schedule' ? 'active' : ''} h4`}>
                        <i className="icon icon-calendar" /> Calendario
                    </Link>
                </NavLink>
            </SingleLink>

        </StyledDrawer>
    );
}

export default Sidebar